import { upsert } from '../../helpers'

export const TOOGLE_AUTOMATION_STATE = 'opinary/TOOGLE_AUTOMATION_STATE'
export const CLEAR_AUTOMATED_POLLS = 'opinary/CLEAR_AUTOMATED_POLLS'
export const FETCH_AUTOMATED_POLLS = 'opinary/FETCH_AUTOMATED_POLLS'
export const FETCH_AUTOMATED_POLLS_SUCCESS =
  'opinary/FETCH_AUTOMATED_POLLS_SUCCESS'
export const FETCH_AUTOMATED_POLLS_ERROR = 'opinary/FETCH_AUTOMATED_POLLS_ERROR'

export const clearAutomatedPolls = () => ({ type: CLEAR_AUTOMATED_POLLS })

export const fetchAutomatedPolls = () => ({ type: FETCH_AUTOMATED_POLLS })

export const toogleAutomationState = id => ({
  type: TOOGLE_AUTOMATION_STATE,
  payload: {
    id,
    automationDisabled: true,
  },
})

export const fetchAutomatedPollsSuccess = polls => ({
  type: FETCH_AUTOMATED_POLLS_SUCCESS,
  payload: { polls },
})

export const fetchAutomatedPollsError = error => ({
  type: FETCH_AUTOMATED_POLLS_ERROR,
  payload: { error },
})

const initialState = {
  polls: {},
  loading: false,
  error: false,
}

export const selectAutomatedPolls = (rootState: RootState) => {
  if (
    rootState.polls &&
    rootState.polls.automated &&
    rootState.polls.automated.polls
  ) {
    return Object.keys(rootState.polls.automated.polls).map(
      pollId => rootState.polls.automated.polls[pollId]
    )
  }

  return []
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AUTOMATED_POLLS:
      return {
        polls: state.polls,
        loading: true,
        error: false,
      }

    case FETCH_AUTOMATED_POLLS_SUCCESS:
      const polls = action.payload.polls.reduce(
        (polls, poll) => ({ ...polls, [poll.id]: poll }),
        {}
      )
      return {
        polls: upsert(state.polls, polls),
        loading: false,
        error: false,
      }

    case FETCH_AUTOMATED_POLLS_ERROR:
      return {
        polls: null,
        loading: false,
        error: action.payload.error,
      }

    case TOOGLE_AUTOMATION_STATE:
      let automated = Object.assign({}, state.polls)
      if (automated[action.payload.id]) {
        automated[action.payload.id].automationDisabled =
          action.payload.automationDisabled
      }
      return {
        ...state,
        polls: automated,
      }

    case CLEAR_AUTOMATED_POLLS:
      return initialState
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/stores/polls/automated.js